import { Fragment } from "react";
import { Link } from "react-router-dom";

function AffiliateInfo() {
  return (
    <Fragment>
      <div className="section-group">
        <div className="section-group-header">
          <h2>About the Program</h2>
        </div>
        <div className="two-column-zigzag">
          <div className="classic-two-column-grid">
            <div className="classic-two-column-left">
              <img
                src="/images/affiliate_what_is.svg"
                alt="What is Affiliate Program"
              ></img>
            </div>
            <div className="classic-two-column-right">
              <div className="group-content">
                <h4>What is the program</h4>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <p>
                    Plaintr gives you a way to earn by introducing your audience
                    to financial services they can actually trust.
                  </p>
                  <p>
                    Behind every experience is real expertise — licensed
                    professionals, structured processes, and a platform built
                    for clarity.
                  </p>
                  <p>
                    You connect people to something better — and the system
                    tracks and rewards the impact you create.
                  </p>
                  <p>Simple on the surface. Powerful underneath.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="classic-two-column-grid">
            <div className="classic-two-column-left">
              <img
                src="/images/affiliate_who_can.svg"
                alt="Who can join the Affiliate Program"
              ></img>
            </div>
            <div className="classic-two-column-right">
              <div className="group-content">
                <h4>Who can join</h4>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <p>This is built for people who influence decisions.</p>
                  <p>
                    If your audience listens, your clients trust you, or your
                    community follows your lead, this becomes a natural
                    extension of what you already do.
                  </p>
                  <p>
                    Creators, professionals, operators, and communities can all
                    participate.
                  </p>
                  <p>If you drive decisions, you can drive earnings.</p>
                </div>
              </div>
              <div className="cta-group">
                <Link className="cta-button primary" to="/sign-up">
                  Join Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default AffiliateInfo;
